<template>
	<b-overlay :show="show" class="confirmation" no-wrap>
		<template slot="overlay">
			<div ref="dialog"
				 tabindex="-1"
				 role="dialog"
				 aria-modal="false"
				 aria-labelledby="form-confirm-label"
				 class="text-center p-3">
				<p id="form-confirm-label" v-html="confirmation.text"></p>
				<div>
					<b-button class="btn-default btn-grey mr-3" @click="onCancel">Cancel</b-button>
					<b-button class="btn-default btn-green" @click="onOK">OK</b-button>
				</div>
			</div>
		</template>
	</b-overlay>
</template>

<script>
    export default {
        name: 'Confirmation',
        computed: {
            show: function () { return this.$store.state.Confirmation.show },
            confirmation: function () { return this.$store.state.Confirmation.confirmation }
        },
        methods: {
            onCancel() {
                if (this.confirmation.cancelCallback)
                    this.confirmation.cancelCallback()

                this.$store.commit("Confirmation/hide")
            },
            onOK() {
                if (this.confirmation.okCallback)
                    this.confirmation.okCallback()

                this.$store.commit("Confirmation/hide")
            }
        }
    }
</script>

<style scoped>
	.confirmation {
		position: fixed !important;
		z-index: 10000000 !important;
	}

	.btn.btn-default.btn-green {
		margin: 0;
	}
</style>